import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$RESET_OPEN_PURCHASE_CHOICE_SETS/REQUESTED';
const BLOCKED = '$RESET_OPEN_PURCHASE_CHOICE_SETS/BLOCKED';
const APPROVED = '$RESET_OPEN_PURCHASE_CHOICE_SETS/APPROVED';
const SUCCEEDED = '$RESET_OPEN_PURCHASE_CHOICE_SETS/SUCCEEDED';
const FAILED = '$RESET_OPEN_PURCHASE_CHOICE_SETS/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      targetChoiceSetIds: string[];
    }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      purchase: _Purchase;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
